export default [
  {
    path: '/health-items',
    name: 'health-item',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-healt/health-item/index-v2.vue')
  },
  {
    path: '/health-items/:id',
    name: 'health-item-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-healt/health-item/index.vue'),
    props: route => ({ editData: route.params.editData })
  }
]
